import { addUpdateCardShopifyErrorsMap } from "./constants";
import defaultTranslations from "./defaultTranslations";
import { getDateStrFromEpoch } from "./helpers";

class Translate {
    static _data: any = { ...defaultTranslations };

    static fetch() {
        return this._data || {};
    }
    static set(data: any) {
        this._data = { ...this._data, ...data };
    }
}

export function replacePlaceholders(str: string, placeholders: any) {
    let _str = str;
    if (str && placeholders) {
        Object.keys(placeholders).forEach((key) => {
            if (placeholders[key] != undefined || placeholders[key] != null) {
                _str = _str.replace(
                    new RegExp(`{{${key}}}`, "g"),
                    placeholders[key],
                );
            } else {
                _str = _str.replace(new RegExp(`{{${key}}}`, "g"), "");
            }
        });
    }
    return _str;
}

export function translate(key: string, placeholders: any = {}) {
    const data = Translate.fetch();
    const str = data[key] || defaultTranslations[key];
    return replacePlaceholders(str, placeholders);
}

export function translateDateEpoch(
    dateEpochSecs: number,
    showInternationalDateFormat: boolean = false,
    locale: string,
    country: string,
) {
    const data = Translate.fetch();

    if (showInternationalDateFormat) {
        const options = {
            dateStyle: "long" as const,
        };
        const locales = `${locale.split("-")[0]}-${country}`;
        return new Intl.DateTimeFormat(locales, options).format(
            new Date(dateEpochSecs * 1000),
        );
    }

    let months = [
        data.month_jan,
        data.month_feb,
        data.month_mar,
        data.month_apr,
        data.month_may,
        data.month_jun,
        data.month_jul,
        data.month_aug,
        data.month_sep,
        data.month_oct,
        data.month_nov,
        data.month_dec,
    ];
    let _date = new Date(dateEpochSecs * 1000);

    let date = _date.getDate();
    let month = _date.getMonth();
    let year = _date.getFullYear();

    if (year && date && month !== null && month !== undefined && month >= 0) {
        return `${months[month]} ${date}, ${year}`;
    }
    return getDateStrFromEpoch(dateEpochSecs);
}

export function translateIntervals(intervalCount: number, interval: string) {
    const data = Translate.fetch();
    if (interval) {
        if (intervalCount > 1) {
            if (interval.toUpperCase() === "DAY") {
                return data.interval_multiple_days.replace(
                    "{{number}}",
                    intervalCount,
                );
            } else if (interval.toUpperCase() === "MONTH") {
                return data.interval_multiple_months.replace(
                    "{{number}}",
                    intervalCount,
                );
            } else if (interval.toUpperCase() === "WEEK") {
                return data.interval_multiple_weeks.replace(
                    "{{number}}",
                    intervalCount,
                );
            } else if (interval.toUpperCase() === "YEAR") {
                return data.interval_multiple_years.replace(
                    "{{number}}",
                    intervalCount,
                );
            }
        } else {
            if (interval.toUpperCase() === "DAY") {
                return `${intervalCount} ${data.interval_single_day}`;
            } else if (interval.toUpperCase() === "MONTH") {
                return `${intervalCount} ${data.interval_single_month}`;
            } else if (interval.toUpperCase() === "WEEK") {
                return `${intervalCount} ${data.interval_single_week}`;
            } else if (interval.toUpperCase() === "YEAR") {
                return `${intervalCount} ${data.interval_single_year}`;
            }
        }
    }
    return `${intervalCount} ${interval}`;
}

export function translateLocalizedEntity(
    entityType: string,
    entityId: number,
    fieldKey: string,
    defaultValue: string,
    placeholders: any = {},
) {
    let _key = `${entityType}_${entityId}_${fieldKey}`;
    const data = Translate.fetch();
    let str = data[_key] || defaultValue;
    return replacePlaceholders(str, placeholders);
}

export function setTranslationData(
    locale: string,
    entityType: string,
    productHandle: string,
    data: any,
) {
    let _key = `${locale}_${entityType}_${productHandle}`;
    Translate.set({ [_key]: data.product[entityType] });
}

export function fetchTranslationData(
    locale: string,
    entityType: string,
    productHandle: string,
) {
    let _key = `${locale}_${entityType}_${productHandle}`;
    const _data = Translate.fetch();
    return _data[_key];
}

export function setTranslationDataVariant(
    locale: string,
    entityType: string,
    productHandle: string,
    variant_title: string,
    translation: string,
) {
    let _key = `${locale}_${entityType}_${productHandle}_${variant_title}`;
    Translate.set({ [_key]: translation });
}

export function fetchTranslationDataVariant(
    locale: string,
    entityType: string,
    productHandle: string,
    variant_title: string,
) {
    let _key = `${locale}_${entityType}_${productHandle}_${variant_title}`;
    const _data = Translate.fetch();
    return _data[_key];
}

function getCardAddUpdateTranslation(
    defaultValue: string,
    key: string,
    entityId: number,
    placeholders: any,
) {
    const translation = translateLocalizedEntity(
        "PAYMENT",
        entityId,
        key,
        defaultValue,
        placeholders,
    );
    return translation;
}

export const getCardAddUpdateTranslatedErrors = (
    entityId: number,
    errors = [],
) => {
    const defaultMaps = addUpdateCardShopifyErrorsMap;
    const translatedErrors = [];

    errors.forEach((error) => {
        let matchedKey = null;
        for (const [key, value] of Object.entries(defaultMaps)) {
            if (error.includes(value)) {
                matchedKey = key;
                break;
            }
        }

        const translation = getCardAddUpdateTranslation(
            error,
            matchedKey,
            entityId,
            {},
        );
        translatedErrors.push(translation);
    });

    return translatedErrors;
};

export default Translate;
